import { getRequest } from './api';

const brandMetricsApi = {
  async getConfiguredBrands() {
    const res = await getRequest('/admin/brand-metrics/brands');
    return res?.data ?? res;
  },

  async getBrandsOverview(start, end) {
    const res = await getRequest(`/admin/brand-metrics/overview?start=${start}&end=${end}`);
    return res?.data ?? res;
  },

  async getBrandPanel(brandId, start, end) {
    const res = await getRequest(
      `/admin/brand-metrics/${brandId}?start=${start}&end=${end}`
    );
    return res?.data ?? res;
  },

  async getMyPanel(start, end) {
    const res = await getRequest(`/brand-metrics/my-panel?start=${start}&end=${end}`);
    return res?.data ?? res;
  },

  async getBrandCampaigns(brandId, start, end) {
    const res = await getRequest(
      `/admin/brand-metrics/${brandId}/campaigns?start=${start}&end=${end}`
    );
    return res?.data ?? res;
  },

  async getMyCampaigns(start, end) {
    const res = await getRequest(`/brand-metrics/my-campaigns?start=${start}&end=${end}`);
    return res?.data ?? res;
  },

  async getBrandCatalog(brandId, start, end) {
    const res = await getRequest(
      `/admin/brand-metrics/${brandId}/catalog?start=${start}&end=${end}`
    );
    return res?.data ?? res;
  },

  async getMyCatalog(start, end) {
    const res = await getRequest(`/brand-metrics/my-catalog?start=${start}&end=${end}`);
    return res?.data ?? res;
  },

  async getBrandCreativePreview(brandId, creativeId, adFormat = 'MOBILE_FEED_STANDARD') {
    const res = await getRequest(
      `/admin/brand-metrics/${brandId}/creatives/${creativeId}?ad_format=${adFormat}`
    );
    return res?.data ?? res;
  },

  async getMyCreativePreview(creativeId, adFormat = 'MOBILE_FEED_STANDARD') {
    const res = await getRequest(`/brand-metrics/my-creatives/${creativeId}?ad_format=${adFormat}`);
    return res?.data ?? res;
  },
};

export default brandMetricsApi;
